import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import ReactTooltip from 'react-tooltip';

const styles = require('./progress-bar.css');

export interface ProgressBarProps {
  /** Additional classes for the container */
  className?: string;
  /** Number of items completed from the total */
  progress: number;
  /** Total  */
  total: number;
  showTooltip?: boolean;
  dataTour?: string;
}

/** Circular Progress Bar  */
@observer
export class ProgressBar extends React.Component<ProgressBarProps> {
  render() {
    const width =
      this.props.progress >= this.props.total ? '100%' : `${(100 * this.props.progress) / this.props.total}%`;
    /// FF2-353: showTooltip is disabled (doesn't work consistently anyway)
    /// FF2-436: Set data-tour attribute for walkthroughs. This will look for "progressBar:0"
    return (
      <React.Fragment>
        <div
          className={classnames(styles.container, this.props.className)}
          data-for={'progressTip'}
          data-tip={`${this.props.progress}/${this.props.total} complete`}
          data-tour={this.props.dataTour}
        >
          <div className={styles.background}>
            <div style={{ width }} className={styles.progress} />
          </div>
        </div>
        {/* {this.props.showTooltip ? <ReactTooltip id="progressTip" place="top" effect="solid"  type="dark" className={styles.progressTip}/> : null} */}
        <ReactTooltip id="progressTip" place="top" effect="solid" type="dark" className={styles.progressTip} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/ui/widgets/progress-bar/progress-bar.tsx